"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputRange = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
// TODO this package hasn't been updated in a while. Consider changing for a more maintained one
const react_input_range_1 = __importDefault(require("react-input-range"));
const react_i18next_1 = require("react-i18next");
const default_class_names_1 = __importDefault(require("react-input-range/src/js/input-range/default-class-names"));
require("react-input-range/lib/css/index.css");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const InputCheckbox_1 = __importDefault(require("chaire-lib-frontend/lib/components/input/InputCheckbox"));
const InputRange = (props) => {
    const [value, setValue] = react_1.default.useState(props.value);
    const { t, i18n } = (0, react_i18next_1.useTranslation)();
    const labels = props.widgetConfig.labels;
    const labelItems = labels
        ? labels.map((label, idx) => {
            const labelStr = surveyHelper.translateString(label, i18n, props.interview, props.path, props.user);
            return (react_1.default.createElement("p", { key: `inputRange_${props.id}_label_${idx}`, className: `__input-range_input_container_label${idx > 0 && idx < labels.length - 1
                    ? ' __input-range_input_container_label_middle'
                    : idx === labels.length - 1
                        ? ' __input-range_input_container_label_last'
                        : ''}` }, labelStr));
        })
        : [];
    if (props.widgetConfig.trackClassName) {
        default_class_names_1.default.track = props.widgetConfig.trackClassName;
    }
    const formatLabelFct = props.widgetConfig.formatLabel;
    const maxValue = !(0, LodashExtensions_1._isBlank)(props.widgetConfig.maxValue) ? props.widgetConfig.maxValue || 100 : 100;
    const minValue = !(0, LodashExtensions_1._isBlank)(props.widgetConfig.minValue) ? props.widgetConfig.minValue || -10 : -10;
    return (react_1.default.createElement("div", { className: `survey-question__input-range_input_container_with_labels${(0, LodashExtensions_1._isBlank)(value) ? ' input-blank' : ''}` },
        react_1.default.createElement(react_input_range_1.default, { name: props.id, ariaLabelledby: `${props.id}_label`, 
            // defaultValue = {_isBlank(this.props.value) ? this.props.widgetConfig.defaultValue : this.props.value }
            ref: props.inputRef, maxValue: maxValue, minValue: minValue, formatLabel: formatLabelFct !== undefined
                ? (value) => formatLabelFct(value, i18n.language)
                : (value) => String(value), value: typeof value === 'number' && value >= minValue ? value : minValue, classNames: default_class_names_1.default, disabled: typeof value === 'string', onChange: (value) => setValue(value), onChangeComplete: (value) => {
                if (typeof value === 'number' && value < minValue) {
                    props.onValueChange({ target: { value: null } });
                }
                else {
                    props.onValueChange({ target: { value } });
                }
            } }),
        labelItems.length > 0 && (react_1.default.createElement("div", { className: 'survey-question__input-range_input_labels_container' }, labelItems)),
        props.widgetConfig.includeNotApplicable === true && (react_1.default.createElement(InputCheckbox_1.default, { id: `${props.id}_na`, onValueChange: (newVal) => {
                if (newVal.target.value.length > 0) {
                    setValue('na');
                    props.onValueChange({ target: { value: 'na' } });
                }
                else {
                    setValue(undefined);
                    props.onValueChange({ target: { value: undefined } });
                }
            }, value: value === 'na' ? ['na'] : [], choices: [
                {
                    value: 'na',
                    label: surveyHelper.translateString(props.widgetConfig.notApplicableLabel, i18n, props.interview, props.path, props.user) || t(['survey:main:NotApplicable', 'main:NotApplicable'])
                }
            ] }))));
};
exports.InputRange = InputRange;
exports.default = exports.InputRange;
//# sourceMappingURL=InputRange.js.map